__turbopack_context__.v({
  "overlay": "Sidebar-module-scss-module__fUWVYG__overlay",
  "overlay-entered": "Sidebar-module-scss-module__fUWVYG__overlay-entered",
  "overlay-entering": "Sidebar-module-scss-module__fUWVYG__overlay-entering",
  "sidebarContainer": "Sidebar-module-scss-module__fUWVYG__sidebarContainer",
  "sidebarContainer-left": "Sidebar-module-scss-module__fUWVYG__sidebarContainer-left",
  "sidebarContainer-left-entered": "Sidebar-module-scss-module__fUWVYG__sidebarContainer-left-entered",
  "sidebarContainer-right": "Sidebar-module-scss-module__fUWVYG__sidebarContainer-right",
  "sidebarContainer-right-entered": "Sidebar-module-scss-module__fUWVYG__sidebarContainer-right-entered",
  "sidebarRoot": "Sidebar-module-scss-module__fUWVYG__sidebarRoot",
});
